import classes from "./styles.module.scss";
import { FadeIn } from "react-slide-fade-in";
import * as components from "./components";

/**
 *
 * @param items
 * @param allowedComponents
 * @returns {JSX.Element}
 * @constructor
 */
export const Content = ({ items, additionalComponents }) => {
  const allowedComponents = {
    ...components,
    ...additionalComponents,
  };

  return (
    <div className={classes.content}>
      {items.map(({ component, id, props }, k) => (
        <FadeIn from="bottom" delayInMilliseconds={150} key={k}>
          {id && <a id={id} />}
          {(() => {
            if (typeof component !== "undefined" && component in allowedComponents) {
              const Component = allowedComponents[component];

              return <Component {...props} />;
            }
          })()}
        </FadeIn>
      ))}
    </div>
  );
};

Content.defaultProps = {
  items: [],
  additionalComponents: {},
};
